export async function resolveApiRequest (request, catchErrors, catchError) {
  if (!catchErrors) {
    return await request
  }

  return await request.catch(e => catchError(e))
}
